module.exports = new __parcel__URL__("jaws.09a09e40.jpg").toString();